<template>
	<v-app style="background: #eee" class="pa-3">
		<span class="display-1 font-weight-light">Your email has not been verified.</span>
		<v-divider />
		<br />
		<span class="subheading mb-2">
		Verify your email with the link sent to you.
		</span>
		<v-container style="padding: 0px; margin: 0px;">
			<v-btn color="#35455c" class="amber--text">Send Verification Link</v-btn>
		</v-container>
		<span class="subheading">
		{{message}}
		</span>
		<v-snackbar
			v-model="snackbar"
		    :color="color"
		    :multi-line="mode === 'multi-line'"
		    :timeout="timeout"
		    :vertical="mode === 'vertical'"
		>{{ text }}</v-snackbar>
	</v-app>
</template>
<script>
import firebase from 'firebase'
export default {
	data(){
		return {
	        snackbar: false,
	        color: '',
	        mode: '',
	        timeout: 4000,
	        text: '',
			buttonDisableStatus : false,
			interval2 : null,
			message : null,
			verificationStatus : false,
			interval : null,
			counter : 60
		}
	}, 
	methods : {
		timeout1 : function () {
			this.counter=this.counter-1;
			this.message="Retry in "+this.counter+" seconds.";
		},
		send : function () {
			var vm=this;
			var actionCodeSettings={
				url : "http://campusbox-e0794.firebaseapp.com/login"
			}
			firebase.auth().currentUser.sendEmailVerification(actionCodeSettings).then(function () {
				vm.interval2=setInterval(()=> vm.timeout1(),1000);
				vm.buttonDisableStatus=true;
			}).catch(function (error) {
				vm.color="error";
				vm.text="Error Sending Verification, Try again later.";
				vm.snackbar=true;
			})
		},
		getVerificationStatus : function () {
			var vm = this;
			firebase.auth().currentUser.reload().then(function () {
				vm.verificationStatus=firebase.auth().currentUser.emailVerified;
			});
		}
	},
	watch : {
		counter : function () {
			var vm=this;
			if (vm.counter==0){
				vm.counter=60;
				vm.buttonDisableStatus=false;
				vm.message='';
				clearInterval(vm.interval2);
			}
		},
		verificationStatus : function () {
			var vm=this;
			if(vm.verificationStatus){
				vm.text="Email Verified Successfully.";
				vm.color="success";
				vm.snackbar=true;
				setTimeout(function () {
					vm.$router.push('/home/default');
				},1500);
			}
		}
	},
	created(){
		this.interval=setInterval(()=> this.getVerificationStatus(),1000);
	},
	beforeDestroy(){
		clearInterval(this.interval);
	}
};
</script>